import {filterData} from "../components/DropdownFilter";

const handleFilter = (id: number, value: string,
    dropdownData: filterData[], filter: filterData[]) => {
    const temp = [...filter];
    const index = temp.findIndex((data)=> data.id === id);
    if (index >= 0) {
        if (id === 0) {temp.splice(0, temp.length);}
        else {
            const index = filter.findIndex((data)=> data.id === id);
            temp.splice(index, 1);
        }
    } else {
        if (id === 0) {
            temp.splice(0, temp.length);
            temp.push(...dropdownData);
        }
        else {temp.push({id, value});}
    }
    if (temp.length !== dropdownData.length) {
        const index = temp.findIndex((data)=> data.id === 0);
        if (index >=0) {temp.splice(index, 1);}
        else if (index === -1 &&
            temp.length === (dropdownData.length-1)) {temp.push(
            {id: 0, value: 'All'});}
    }
    return temp;
}

const isFilterSelected = (id: number, filter: filterData[]) => {
    const index = filter.findIndex((data)=> data.id === id);
    if (index>=0) {return true;}
    else {return false;}
}


export {handleFilter, isFilterSelected};